module.exports = __webpack_public_path__ + "7e547a7b222366bbb1001343b94c0e42.svg";